import React from 'react';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';
import { Checkbox } from '@scale/scaleui';

const BooleanInputBuilder: React.FC<{
  name: string;
  updateProperty: (value: any) => void;
  existingValue?: boolean;
  required?: boolean;
  hint?: string;
  disabled?: boolean;
}> = ({ name, updateProperty, existingValue, hint, disabled }) => {
  return (
    <div className="flex items-center">
      <Checkbox
        checked={existingValue === true}
        label={name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          updateProperty(e.target.checked);
        }}
        disabled={!!disabled}
      />
      {hint && <BuilderHint name={name} hint={hint} />}
    </div>
  );
};

export default BooleanInputBuilder;
